export default __webpack_public_path__ + "static/media/taobao1.b8ff3257.png";